@if (value$ | async; as value) {
  <p class="supplier-contact-cell">
    @if (value.supplierContactName) {
      <span>{{ value.supplierContactName }}<br /></span>
    }
    @if (value.supplierContactPhoneNumber) {
      <span>{{ value.supplierContactPhoneNumber }}<br /></span>
    }
    @if (value.supplierContactMail) {
      <span>{{ value.supplierContactMail }}<br /></span>
    }
  </p>
}
